import { useContext, useState } from "react";
import { ReactComponent as AddIcon } from "../../../../../../assets/icons/MedintAddIcon.svg";
import { ReactComponent as ModifyIcon } from "../../../../../../assets/icons/MedintModifyIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../../../assets/icons/MedintDeleteIcon.svg";
import { Typography, Grid, Button, Stack, IconButton } from "@mui/material";
import { RHFAutocomplete } from "../../../../../RHFComponents/RHFComponents";
import { UseFormReturn } from "react-hook-form";
import MedintFormInterface from "../../../../../../services/medintInterfaces";
import { MedintDataContext } from "../../../../Context/MedintContextWrapper";
import { StyledDataGrid } from "../../../../../AppointmentManagement/AppointmentManagementDetail/AppointmentManagementDetail";
import { GridColDef } from "@mui/x-data-grid";
import ModalRicoveri from "./ModalRicoveri";
import { eqmed } from "../../../../../../networking";

const FormRicoveri = (props: {
  methods: UseFormReturn<MedintFormInterface>;
  fetchDataMedico: () => Promise<void>;
  allertMessageProps: {
    showAllert: boolean;
    setShowAllert: React.Dispatch<React.SetStateAction<boolean>>;
    setMessage: React.Dispatch<React.SetStateAction<string>>;
    setSeverity: React.Dispatch<React.SetStateAction<string>>;
    severity: string;
    message: string;
    dataToSend: any;
    submitFunction: (() => void) | null;
    setFn: React.Dispatch<React.SetStateAction<(() => void) | null>>;
  };
}) => {
  const context = useContext(MedintDataContext);

  const [open, setOpen] = useState<boolean>(false);

  const onClickCancellazioneEquipe = async (data: any) => {
    props.allertMessageProps.setFn(() => () => handleDelete(data));
    props.allertMessageProps.setMessage(
      "Procedere con la rimozione di questo medico dall'equipe?",
    );
    props.allertMessageProps.setSeverity("warning");
    props.allertMessageProps.setShowAllert(true);
  };

  // Colonne griglia
  const equipeCols: GridColDef[] = [
    { field: "id" },
    { field: "nominMedint", headerName: "Medico", flex: 1 },
    { field: "desMansio", headerName: "Mansione", flex: 1 },
    {
      field: "azioni",
      headerAlign: "center",
      align: "center",
      headerName: "Azioni",
      flex: 0.5,
      renderCell: (params: any) => (
        <>
          <IconButton
            size="small"
            onClick={() => handleEdit(params.row)}
            sx={{
              color: "#024E88",
            }}
          >
            <ModifyIcon />
          </IconButton>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onClickCancellazioneEquipe(params.row);
            }}
            sx={{
              color: "#D32F2F",
            }}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  const handleEdit = (data: any) => {
    props.methods.setValue(
      "medIntRicoveriInterventi.modalFormValues.state",
      "u",
    );
    props.methods.setValue(
      "medIntRicoveriInterventi.modalFormValues.mansCod",
      data.codMansio,
    );
    props.methods.setValue(
      "medIntRicoveriInterventi.modalFormValues.medComp",
      data.codMedInt,
    );
    props.methods.setValue(
      "medIntRicoveriInterventi.modalFormValues.idEquMed",
      data.idEquMed,
    );
    setOpen(true);
  };

  const handleDelete = async (data: any) => {
    props.methods.setValue(
      "medIntRicoveriInterventi.modalFormValues.state",
      "d",
    );
    props.methods.setValue(
      "medIntRicoveriInterventi.modalFormValues.mansCod",
      data.codMansio,
    );
    props.methods.setValue(
      "medIntRicoveriInterventi.modalFormValues.medComp",
      data.codMedInt,
    );
    props.methods.setValue(
      "medIntRicoveriInterventi.modalFormValues.idEquMed",
      data.idEquMed,
    );

    try {
      const response = await eqmed({
        crud: "d",
        prgint:
          props.methods.getValues(
            "medIntRicoveriInterventi.modalFormValues.idEquMed",
          ) ?? "",
        dati: {
          equmed: {
            MEDINT_PRGINT: context?.selectedDoctor?.pkey,
            MEDINT_CODICE: props.methods.getValues(
              "medIntRicoveriInterventi.modalFormValues.medComp",
            ),
            MANSIO_CODICE: props.methods.getValues(
              "medIntRicoveriInterventi.modalFormValues.mansCod",
            ),
            EQUMED_NORMALIZZAZIONE: "",
          },
        },
      });

      props.allertMessageProps.setMessage(response.data.messaggio);

      console.log("Risposta della send", response);

      if (response.data.esito === "OK") {
        props.allertMessageProps.setSeverity("success");
      } else if (response.data.esito === "KO") {
        props.allertMessageProps.setSeverity("warning");
      } else {
        props.allertMessageProps.setSeverity("error");
        props.allertMessageProps.setMessage(
          "Cancellazione database fallita, contattare l'amministratore",
        );
      }
    } catch (error) {
      console.warn("Si è presentato un errore durante l'inserimento", error);
    } finally {
      props.allertMessageProps.setShowAllert(true);
      setTimeout(() => {
        handleClose();
        props.allertMessageProps.setShowAllert(false);
      }, 5000);
    }
  };

  const handleClose = () => {
    setOpen(false);
    props.fetchDataMedico();
  };

  return (
    <>
      <ModalRicoveri
        open={open}
        methods={props.methods}
        fetchDataMedico={props.fetchDataMedico}
        allertMessageProps={props.allertMessageProps}
        handleClose={handleClose}
      />
      <Grid container spacing={2} direction={"row"}>
        <Grid item xs={12}>
          <RHFAutocomplete
            control={props.methods.control}
            sx={{ mt: 2 }}
            name="medIntDettaglio.unitErogPrin"
            label="Unità Erogatrice Principale"
            options={context?.listaUnitaErogatrici ?? []}
            keyField="id"
            isOptionEqualToValue={(a, b) =>
              String(a?.codUnErog) === String(b?.codUnErog)
            }
            getOptionLabel={(d: any) =>
              `${d.codUnErog ?? "N/a codice"} - ${d.desUnErog ?? "N/a Descrizione"}`.trim()
            }
            mapIn={(id, opts) =>
              opts.find(
                (o: any) => String(o?.codUnErog ?? o?.id) === String(id),
              ) ?? null
            }
            mapOut={(opt: any) =>
              String(opt?.codUnErog ?? opt?.id ?? "") || null
            }
          />
        </Grid>
        <Grid item xs={12}>
          <RHFAutocomplete
            control={props.methods.control}
            sx={{ mt: 1 }}
            name="medIntDettaglio.codVisInterv"
            label="Medico visita per intervento"
            options={context?.doctorsData ?? []}
            keyField="id"
            getOptionLabel={(d: any) =>
              `${d?.["codice medico"] ?? "N/a codice"} - ${d?.cognome ?? "N/A nome"} ${d?.nome ?? "N/A cognome"}`.trim()
            }
            mapIn={(id, opts) =>
              opts.find(
                (o: any) =>
                  String(o?.["codice medico"] ?? o.pkey) === String(id),
              ) ?? null
            }
            mapOut={(opt: any) =>
              String(opt?.["codice medico"] ?? opt?.pkey ?? "") || null
            }
          />
        </Grid>
        <Grid item xs={12}>
          <RHFAutocomplete
            control={props.methods.control}
            sx={{ mt: 1 }}
            name="medIntDettaglio.codEsecInterv"
            label="Medico esecutore intervento"
            options={context?.doctorsData ?? []}
            keyField="id"
            getOptionLabel={(d: any) =>
              `${d?.["codice medico"] ?? "N/a codice"} - ${d?.cognome ?? "N/A nome"} ${d?.nome ?? "N/A cognome"}`.trim()
            }
            mapIn={(id, opts) =>
              opts.find(
                (o: any) =>
                  String(o?.["codice medico"] ?? o.pkey) === String(id),
              ) ?? null
            }
            mapOut={(opt: any) =>
              String(opt?.["codice medico"] ?? opt?.pkey ?? "") || null
            }
          />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            borderRadius: "4px",
            border: "1px solid #CCC",
            ml: 2,
            mt: 2,
            pr: 2,
            pb: 2,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                Équipe
              </Typography>
            </Grid>
            <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
              <Button
                variant="outlined"
                sx={{
                  maxHeight: "35px",
                  maxWidth: "110px",
                  mt: 0.5,
                }}
                onClick={() => {
                  setOpen(true);
                  props.methods.setValue(
                    "medIntRicoveriInterventi.modalFormValues.state",
                    "c",
                  );
                  props.methods.setValue(
                    "medIntRicoveriInterventi.modalFormValues.mansCod",
                    "",
                  );
                  props.methods.setValue(
                    "medIntRicoveriInterventi.modalFormValues.medComp",
                    "",
                  );
                }}
              >
                <Stack gap={1} direction={"row"}>
                  <AddIcon className="medintIcons" />
                  <Typography sx={{ fontWeight: "bold" }}>Inserisci</Typography>
                </Stack>
              </Button>
            </Grid>
            <Grid item xs={12} display={"flex"} pl={2} pt={2}>
              <StyledDataGrid
                rows={
                  props.methods.getValues("medIntRicoveriInterventi.equipe") ??
                  []
                }
                columns={equipeCols}
                getRowId={(r) => r.id}
                columnVisibilityModel={{
                  id: false,
                }}
                sortingOrder={["desc", "asc", null]}
                sx={{
                  height: 200,
                  '& .MuiDataGrid-columnHeaders [data-field="__orderBySelected__"] .MuiDataGrid-sortIcon':
                    {
                      display: "none",
                    },
                  "& .MuiDataGrid-row.Mui-selected": {
                    backgroundColor: "#e3f2fd",
                  },
                  "& .MuiDataGrid-row.Mui-selected:hover": {
                    backgroundColor: "#bbdefb",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default FormRicoveri;
